import { Form } from "@client/content/controls";
import { getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import { type ControlFormField, type FormButtonProps, type FormFieldInfo } from "@client/controls/Form/component";
import EmailInput from "@client/controls/Inputs/Email/component";
import TextArea from "@client/controls/Inputs/TextArea/component";
import TextInput from "@client/controls/Inputs/TextInput/component";
import { getCurrentUserId } from "@client/lib/cookie";
import appInfo from "@common/appInfo";
import { fieldValidation } from "@common/controls/Form/Field/lib";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import { type BlogDetailComments } from "../../types";

export type MapProps = RootContainerProps & {
  isAdding: boolean;
  commentsCount: number;
};

export interface ActionProps {
  onClick: (data: BlogDetailComments.View.AddCommentFormData) => void;
}

export type Props = ActionProps & MapProps;

export default (props: Props) => {
  const i18n = useI18n();

  const FormButton = (innerProps: FormButtonProps) => (
    <ModuleButton
      {...getRootContainerProps(props)}
      className="btn_comment"
      isDisabled={props.isAdding}
      onClick={innerProps.ifValidated(props.onClick)}
    />
  );

  const fields = React.useMemo((): FormFieldInfo[] => {
    const isUserKnown = !!appInfo.user?.id || !!getCurrentUserId();

    const fields: ControlFormField[] = isUserKnown
      ? []
      : [
          {
            name: "name",
            label: i18n.name,
            colSpan: 6,
            isRequired: true,
            Component: TextInput,
            defaultValue: ""
          },
          {
            name: "email",
            label: i18n.email,
            colSpan: 6,
            isRequired: true,
            Component: EmailInput,
            validation: fieldValidation.email,
            defaultValue: ""
          }
        ];

    fields.push({
      name: "comment",
      label: i18n.message,
      Component: TextArea,
      componentOpts: { rows: 6, cols: 10, style: { resize: "vertical" } },
      isRequired: true,
      defaultValue: ""
    });

    return fields;
  }, []);

  return (
    <Form
      {...getRootContainerProps(props)}
      fields={fields}
      Button={FormButton}
      buttonProps={getRootContainerProps(props)}
      resetOnSubmit
    />
  );
};
